import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getYearFromTimestamp } from '../Utils/dateHelpers';

const CurrentMonthEvents = ({ events, loading }) => {
  if (loading) {
    return (
      <section className="events-section">
        <h3 className="section-title">This Month's Events</h3>
        <div className="loading-spinner-small">Loading...</div>
      </section>
    );
  }

  if (!events || events.length === 0) {
    return null;
  }

  return (
    <section className="events-section">
      <h3 className="section-title">This Month's Events</h3>
      <div className="event-list">
        {events.map((event) => (
          <Link
            key={event.eventid}
            to={`/event-page?eventname=${event.eventid}&year=${getYearFromTimestamp(event.event_timestamp)}`}
            style={{ textDecoration: "none" }}
          >
            <motion.div
              className="event-sticker medium"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{background: "rgba(36,36,45,0.2)", border: "1px solid darkslategray"}}
            >
              <img
                src={event.eventimageurl}
                alt={event.eventname}
                className="event-image"
              />
              <h4 className="event-title" style={{color: "white"}}>{event.eventname}</h4>
              <p className="event-date" style={{color: "white"}}>{event.event_timestamp}</p>
            </motion.div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CurrentMonthEvents;
